import type { ReactNode } from 'react';

export type UserBubbleProps = {
    readonly children: ReactNode;
    readonly timestamp?: number;
    readonly timeFormatter?: Intl.DateTimeFormat;
    readonly compact?: boolean;
};

export function UserBubble({ children, timestamp, timeFormatter, compact }: UserBubbleProps) {
    return (
        <div className="group flex flex-col items-end">
            <div className="max-w-[92%] rounded-xl bg-gray-100 px-m py-s shadow-sm">
                <div
                    className={`m-0 whitespace-pre-wrap ${compact ? 'text-xs' : 'text-[13px]'} text-black-900 [overflow-wrap:anywhere]`}
                >
                    {children}
                </div>
            </div>
            {timestamp !== undefined && timeFormatter && (
                <p className="m-0 mt-xxs text-[11px] text-gray-600 opacity-0 transition-opacity duration-150 group-hover:opacity-100">
                    {timeFormatter.format(new Date(timestamp))}
                </p>
            )}
        </div>
    );
}
